// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* map-control.css */
.custom-marker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: transparent;
  border-radius: 50%;

  color: #246cb1 !important; /* Change this to the desired color */
}
.custom-marker-icon > svg.MuiSvgIcon-root {
  color: #246cb1 !important; /* Ensure the SVG icon color is overridden */
}

.custom-marker-icon  {
  color: #246cb1 !important; /* Change this to the desired color */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 50%;
  height: 35px;
   width: 35px;
}

#map {
  width: 100%;
  flex-grow: 1;
}

#map-control {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/map/map-control.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;;EAElB,yBAAyB,EAAE,qCAAqC;AAClE;AACA;EACE,yBAAyB,EAAE,4CAA4C;AACzE;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;GACX,WAAW;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* map-control.css */\n.custom-marker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: transparent;\n  border-radius: 50%;\n\n  color: #246cb1 !important; /* Change this to the desired color */\n}\n.custom-marker-icon > svg.MuiSvgIcon-root {\n  color: #246cb1 !important; /* Ensure the SVG icon color is overridden */\n}\n\n.custom-marker-icon  {\n  color: #246cb1 !important; /* Change this to the desired color */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border-radius: 50%;\n  height: 35px;\n   width: 35px;\n}\n\n#map {\n  width: 100%;\n  flex-grow: 1;\n}\n\n#map-control {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
